export { default } from "./routes/search/main/index.tsx";